module.exports = __webpack_public_path__ + "img/en.8184e8d1.svg";